const SvgAuthor = () => {
  return (
    <svg
      style={{ color: "var(--gray1)" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M9 1.5C6.93559 1.5 5.25 3.1856 5.25 5.25C5.25 7.3144 6.93559 9 9 9C11.0644 9 12.75 7.3144 12.75 5.25C12.75 3.1856 11.0644 1.5 9 1.5ZM9 2.625C10.4564 2.625 11.625 3.79359 11.625 5.25C11.625 6.70641 10.4564 7.875 9 7.875C7.54359 7.875 6.375 6.70641 6.375 5.25C6.375 3.79359 7.54359 2.625 9 2.625ZM4.49194 10.5C3.67451 10.5 3 11.1745 3 11.9919V12.5625C3 13.9141 3.85473 14.9596 4.98999 15.5859C6.12525 16.2123 7.56304 16.5 9 16.5C10.437 16.5 11.8747 16.2123 13.01 15.5859C13.978 15.0519 14.7065 14.1985 14.9106 13.125H15.0007V11.9919C15.0007 11.1745 14.3255 10.5 13.5081 10.5H4.49194ZM4.49194 11.625H13.5081C13.7174 11.625 13.8757 11.7826 13.8757 11.9919V12H13.875V12.5625C13.875 13.4609 13.3704 14.1029 12.4666 14.6016C11.5628 15.1002 10.2818 15.375 9 15.375C7.71821 15.375 6.43725 15.1002 5.53345 14.6016C4.62965 14.1029 4.125 13.4609 4.125 12.5625V11.9919C4.125 11.7826 4.28262 11.625 4.49194 11.625Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default SvgAuthor;
